import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import moment from "moment";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  ExportToExcelRiskMitigation,
  ExportToExcelRiskMitigationHis,
  getEngagementForRisk,
  GetRiskMitigationGridData,
  getRiskMitigationHistory,
} from "../../../Helpers/API/APIEndPoints";
import axios from "axios";
import fileDownload from "js-file-download";
import { ImCross } from "react-icons/im";
import { Filter, Height } from "@mui/icons-material";
import { Overlay, Modal } from "react-bootstrap";
import { Tooltip } from "antd";

const RiskMitigation = () => {
  let navigate = useNavigate();
  const { EmployeeId, RoleId } = getContext();
  const [engagementOptions, setEngagementOptions] = useState<any>([]);
  const [selectedEngagement, setSelectedEngagement] = useState<any>();
  const [gridData, setGridData] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState<any>("");
  const [sortDirection, setSortDirection] = useState<any>("");
  const [searchText, setSearchText] = useState<any>("");
  const [count, setCount] = useState<any>(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [isactive, setIsActive] = useState("active");
  const [FormErrors, setFormErrors] = useState<any>({});
  const [isOpen, setIsOpen] = useState<any>(false);
  const [historyGridData, setHistoryGridData] = useState<any>([]);
  const [RiskMitigationId, setRiskMitigationId] = useState<any>();

  useEffect(() => {
    getEngagement();
  }, []);
  useEffect(() => {
    setGridData([]);
    getGridData();
  }, [
    selectedEngagement,
    searchText,
    sortColumn,
    sortDirection,
    start,
    page,
    pageSize,
  ]);

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,

    setCellHeaderProps: () => ({ align: "center" }),

    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    // showCustomToolbar ?
    // customToolbar: () => {
    //   return (
    //     <FormControl sx={{ mt: 1 }}>
    //       <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
    //       <Select
    //         labelId="demo-simple-select-helper-label"
    //         id="demo-simple-select-helper"
    //         label="Active"
    //         value={isactive}
    //         onChange={handleChange}
    //         sx={{
    //           width: 80,
    //           height: 30, // Set the desired height
    //           "&:focus": { color: "success.main" }, // Change text color to green on focus
    //         }}
    //       >
    //         <MenuItem value={"All"}>All</MenuItem>
    //         <MenuItem value={"active"}>Yes</MenuItem>
    //         <MenuItem value={"inactive"}>No</MenuItem>
    //       </Select>
    //     </FormControl>
    //   );
    // },
  };
  const optionsHis = {
    selectableRows: "none",
    count: false,
    rowsPerPage: false,
    serverSide: false,
    rowsPerPageOptions: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false,

    setCellHeaderProps: () => ({ align: "center" }),

    // onChangeRowsPerPage: (num) => {
    //   //   setLimit(num);
    //   //   setNxtPgInfo("");
    //   //   setPrevPgInfo("");
    //   //   setIsPrevOrNext("");
    // },
    // onSearchChange: (searchText) => {
    //   if (searchText !== null) {
    //     setSearchText(searchText);
    //     setStart(0);
    //   } else {
    //     setSearchText("");
    //   }
    // },
    // onColumnSortChange: async (sortColumn, sortDirection) => {
    //   if (sortDirection === "asc") {
    //     await setSortColumn(sortColumn);
    //     await setSortDirection(sortDirection);
    //   }
    //   if (sortDirection === "desc") {
    //     await setSortColumn(sortColumn);
    //     await setSortDirection(sortDirection);
    //   }
    // },
    // onChangePage: async (page) => {
    //   setStart(page * pageSize);
    // },
    // showCustomToolbar ?
    // customToolbar: () => {
    //   return (
    //     <FormControl sx={{ mt: 1 }}>
    //       <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
    //       <Select
    //         labelId="demo-simple-select-helper-label"
    //         id="demo-simple-select-helper"
    //         label="Active"
    //         value={isactive}
    //         onChange={handleChange}
    //         sx={{
    //           width: 80,
    //           height: 30, // Set the desired height
    //           "&:focus": { color: "success.main" }, // Change text color to green on focus
    //         }}
    //       >
    //         <MenuItem value={"All"}>All</MenuItem>
    //         <MenuItem value={"active"}>Yes</MenuItem>
    //         <MenuItem value={"inactive"}>No</MenuItem>
    //       </Select>
    //     </FormControl>
    //   );
    // },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "riskTitle",
      label: "Risk Title",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "responsiblePersons",
      label: "Responsible Person",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "dueDate",
      label: "Due Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value) =>
          value ? moment(value).format("DD-MMM-YYYY") : "",
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let status = tableMeta.tableData[tableMeta.rowIndex].status;
         // console.log("ststus===>", status);
          const obj = { id: id, status: status };
          //console.log(id,'hjsabdjk')
          let data = tableMeta.tableData[tableMeta.rowIndex];

          return (
            <>
              {status && status === "Not Started" ? (
                <>
                  <Tooltip title="Edit" color={customColors[0]}>
                    <a
                      onClick={(e) => {
                        e.preventDefault();

                        navigate("RiskMitigationEdit", { state: obj });
                      }}
                      className="action_icon"
                    >
                      <i className="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip title="View" color={customColors[0]}>
                    <a
                      onClick={(e) => {
                        e.preventDefault();

                        navigate("RiskMitigationEdit", { state: obj });
                      }}
                      className="action_icon"
                    >
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    </a>
                  </Tooltip>
                </>
              )}

              <Tooltip title="History" color={customColors[0]}>
                <a
                  onClick={() => {
                    setIsOpen(true);
                    getHistoryData(id);
                    setRiskMitigationId(id);
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-history" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
    // {
    //   name: "isActive",
    //   label: "Active",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       if (value == "Yes") {
    //         return <i className="fas fa-check"></i>;
    //       } else {
    //         return <i className="fas fa-times"></i>;
    //       }
    //     },
    //   },
    // },
  ];
  const gridColumnsHis = [
    // {
    //   name: "id",
    //   label: "Id",
    //   options: {
    //     display: false,
    //     filter: false,
    //     sort: false,
    //   },
    // },
    // {
    //   name: "riskTitle",
    //   label: "Risk Title",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },
    // {
    //   name: "responsiblePersons",
    //   label: "Responsible Person",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //   },
    // },
    // {
    //   name: "dueDate",
    //   label: "Due Date",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //     customBodyRender: (value) =>
    //       value ? moment(value).format("DD-MMM-YYYY") : "",
    //    },
    // },
    {
      name: "createdByStr",
      label: "User",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "createdDate",
      label: "DateTime",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value) => {
          return moment.utc(value).local().format("DD-MM-YYYY HH:mm:ss");
        },
      },
    },
    {
      name: "remark",
      label: "Remarks",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    // {
    //   name: "",
    //   label: "Action",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       let id = tableMeta.tableData[tableMeta.rowIndex].Id;
    //       let data =  tableMeta.tableData[tableMeta.rowIndex]

    //       return (
    //         <>
    //           <a
    //             onClick={(e) => {
    //               e.preventDefault();

    //               navigate("RiskMitigationEdit", { state: id });
    //             }}
    //           >
    //             <i className="fa fa-pencil" aria-hidden="true"></i>
    //           </a>

    //           <a
    //             onClick={() => {
    //               setIsOpen(true)
    //             }}
    //             style={{marginLeft : '10px'}}
    //           >
    //             <i className="fa fa-history" aria-hidden="true"></i>
    //           </a>

    //         </>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "isActive",
    //   label: "Active",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       if (value == "Yes") {
    //         return <i className="fas fa-check"></i>;
    //       } else {
    //         return <i className="fas fa-times"></i>;
    //       }
    //     },
    //   },
    // },
  ];

  const getGridData = async () => {
    showLoader();
    // let role;

    // if (RoleId.includes(3)) {
    //  role = 3;
    // }
    // else if (RoleId.includes(8)) {
    //   role = 8;
    //  }
    //  else if (RoleId.includes(2)) {
    //   role = 2;
    //  }

    let obj = {
      // EmpId: Number(EmployeeId),
      // RoleId: role ? role:null ,
      start: start,
      pageSize: pageSize,
      SortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      SearchText: searchText,
      EngagementId: selectedEngagement ? selectedEngagement.value : 0,
    };
   // console.log("grid req obj=>", obj);
    const { data } = await APICall(GetRiskMitigationGridData, "POST", obj);
   // console.log("grid data=>", data);
    if (data != null && data != undefined && data.length > 0) {
     // console.log("inside if");
      setGridData(data);
      setCount(data[0].count);
      hideLoader();
    }

    hideLoader();
  };
  const getEngagement = async () => {
    let obj = {};
    if (RoleId.includes(3)) {
      obj = {
        EmployeeId: Number(EmployeeId),
        RoleId: 3,
      };
    } else if (RoleId.includes(8)) {
      obj = {
        EmployeeId: Number(EmployeeId),
        RoleId: 8,
      };
    } else if (RoleId.includes(2)) {
      obj = {
        EmployeeId: Number(EmployeeId),
        RoleId: 2,
      };
    }

   // console.log("engagement req obj", obj);

    const { data } = await APICall(getEngagementForRisk, "POST", obj);
   // console.log("engagement dd =>", data);
    if (data != undefined || data != null) {
      let customArray = data.map((ele: any) => {
        return {
          value: ele.engagementId,
          label: ele.engagementName,
        };
      });
      setEngagementOptions(customArray);
    }
  };

  const getHistoryData = async (id) => {
   // console.log("id=>", id);
    const { data } = await APICall(getRiskMitigationHistory, "POST", { id });
   // console.log("history data=>", data);
    if (data != null) {
      setHistoryGridData(data);
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
     // console.log("engagement event =>", event);
      setSelectedEngagement(event);
    }
  };

  const handleSubmit = async () => {
    let obj = {
      EngagementId: selectedEngagement.value,
    };
   // console.log("req obj==>", obj);
  };

  // const style = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: "60%",
  //   height: "50%",
  //   bgcolor: "background.paper",
  //   border: "2px solid #000",
  //   borderRadius: 3,
  //   boxShadow: 24,
  //   p: 4,
  //   //overflow : 'scroll'
  // };

  const ExportToExcel = async () => {
    showLoader();
    let role;

    if (RoleId.includes(3)) {
      role = 3;
    } else if (RoleId.includes(8)) {
      role = 8;
    } else if (RoleId.includes(2)) {
      role = 2;
    }

    let requestParams = {
      EmpId: Number(EmployeeId),
      RoleId: role ? role : null,
      start: start,
      pageSize: count,
      sortColumn: sortColumn === "" ? "CreatedDateUTC" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      EngagementId: selectedEngagement ? selectedEngagement.value : 0,
      //activeStatusId: isactive,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: ExportToExcelRiskMitigation,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
      .then((response) => {
        fileDownload(response.data, "Risk Mitigation.xlsx");
      })
      .catch((error) => {
        console.error(error.response.data);
      });
    hideLoader();
  };
  const ExportToExcelHis = async () => {
    showLoader();
    // let role;

    // if (RoleId.includes(3)) {
    //  role = 3;
    // }
    // else if (RoleId.includes(8)) {
    //   role = 8;
    //  }
    //  else if (RoleId.includes(2)) {
    //   role = 2;
    //  }

    let requestParams = {
      id: RiskMitigationId,
      // EmpId: Number(EmployeeId),
      // RoleId: role ? role : null,
      // start: start,
      // pageSize: count,
      // sortColumn: sortColumn === "" ? "CreatedDateUTC" : sortColumn,
      // sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      // searchText: searchText,
      // EngagementId : selectedEngagement ? selectedEngagement.value : 0
      //activeStatusId: isactive,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: ExportToExcelRiskMitigationHis,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
      .then((response) => {
        fileDownload(response.data, "Risk Mitigation History.xlsx");
      })
      .catch((error) => {
        console.error(error.response.data);
      });
    hideLoader();
  };

  return (
    <>
      <Heading title={"Risk Mapping"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Engagement </label>
              <SelectForm
                options={engagementOptions}
                placeholder="Select"
                isDisabled={false}
                value={selectedEngagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => navigate("RiskMitigationEdit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={(e) => {
                    selectedEngagement ? ExportToExcel() : e.preventDefault();
                  }}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              columns={gridColumns}
              options={options}
              data={gridData}
            />
          </div>
        </div>
      </div>
      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        backdrop="static"
        keyboard={false}
        centered
        scrollable={true}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Risk Mitigation History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12">
              <DynamicGrid
                columns={gridColumnsHis}
                data={historyGridData}
                options={optionsHis}
              />
            </div>
            <div className="col-lg-12 mt-3">
              <div className="d-flex justify-content-end gap-2">
                <button
                  onClick={() => setIsOpen(false)}
                  className="btn btn-reset"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    selectedEngagement
                      ? ExportToExcelHis()
                      : e.preventDefault();
                  }}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RiskMitigation;
